import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ChartModule } from 'primeng/chart';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { AppTableModule } from 'src/app/components/table/app-table.module';
import { FailExportComponent } from './fail-export/fail-export.component';
import { IntegrationRoutingModule } from './integration-routing.module';
import { IntegrationTokenFormComponent } from './integration-tokens/integration-token-form/integration-token-form.component';
import { IntegrationTokensComponent } from './integration-tokens/integration-tokens.component';
import { IntegrationComponent } from './integration.component';
import { ProductCardComponent } from './order-items-search/components/product-card/product-card.component';
import { ProductRowComponent } from './order-items-search/components/product-row/product-row.component';
import { OrderItemsSearchComponent } from './order-items-search/order-items-search.component';
import { ProductIntegrationFailureComponent } from './product-integration-failure/product-integration-failure.component';
import { SkeeloDashboardComponent } from './skeelo-dashboard/skeelo-dashboard.component';
import { SpecificCarrierPriorityFormComponent } from './specific-carrier-priority/specific-carrier-priority-form/specific-carrier-priority-form.component';
import { SpecificCarrierPriorityComponent } from './specific-carrier-priority/specific-carrier-priority.component';
import { UpdateShippingCompanyActivationComponent } from './update-shipping-company-activation/update-shipping-company-activation.component';
import { UpdateShippingCompanyComponent } from './update-shipping-company/update-shipping-company.component';

@NgModule({
  declarations: [
    IntegrationComponent,
    FailExportComponent,
    UpdateShippingCompanyComponent,
    IntegrationTokensComponent,
    IntegrationTokenFormComponent,
    UpdateShippingCompanyActivationComponent,
    ProductIntegrationFailureComponent,
    OrderItemsSearchComponent,
    ProductCardComponent,
    ProductRowComponent,
    SkeeloDashboardComponent,
    SpecificCarrierPriorityComponent,
    SpecificCarrierPriorityFormComponent
  ],
  imports: [
    CommonModule,
    IntegrationRoutingModule,
    ReactiveFormsModule,
    CalendarModule,
    DropdownModule,
    ChartModule,
    AppTableModule,
    ButtonModule,
    TooltipModule,
    ToastModule,
    ConfirmPopupModule,
    MultiSelectModule,
    InputTextModule,
    InputTextareaModule,
    TabViewModule,
    InputNumberModule,
    ProgressSpinnerModule,
    SelectButtonModule,
    FormsModule,
    DynamicDialogModule,
    TableModule
  ]
})
export class IntegrationModule {}
